<template>
  <div class="mobile-box">
    <div class="mobile-content">
      <div class="m-title-box">
        大数据选址
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        <p>
          基于极能充充电大数据平台的海量行业数据，对选定的建站地址进行智能分析，预测建站后充电车次，运营效率及投资回报率等，为充电站投资决策提供战略支撑。
        </p>
        <p style="margin-top: 10px;">1.地区新能源车辆保有量</p>
        <p style="margin-top: 10px;">2.用户增长速度</p>
        <p style="margin-top: 10px;">3.地区交通出行数据</p>
        <p style="margin-top: 10px;">4.地区土地数据</p>
        <p style="margin-top: 10px;">5.周边竞对数据</p>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">7<span>天</span></div>
          <div class="m-de-item-text">快速选址最快选址</div>
          <div class="m-de-item-text">只需7天</div>
        </div>
        <div class="m-data-explain-item">
          <div class="m-de-item-num">5<span>年</span></div>
          <div class="m-de-item-text">预计静态回收期</div>
          <div class="m-de-item-text">5年以内</div>
        </div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">13<span>%</span></div>
          <div class="m-de-item-text">预计年化投资回报</div>
          <div class="m-de-item-text">率13%以上</div>
        </div>
        <div class="m-data-explain-item">
          <div class="m-de-item-img tz-img1"></div>
        </div>
      </div>

      <div class="m-title-box" style="margin-top: 100px">
        工程建设
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        建设中心生成建设方案及物资采购方案，对在建工程进行施工过程管控，结算中心完成相关财务结算。
      </div>
      <div class="m-peculiarity">
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz4"></div>
          <div class="m-pe-text">
            <div>定制建设</div>
            <div>工程方案</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz5"></div>
          <div class="m-pe-text">
            <div>生成设备</div>
            <div>采购清单</div>
          </div>
        </div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">2 <span>天</span></div>
          <div class="m-de-item-text">选定土地后动工</div>
          <div class="m-de-item-text">建设最短2天</div>
        </div>
        <div class="m-data-explain-item"></div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">60<span>天</span></div>
          <div class="m-de-item-text">完成工程验收通电</div>
          <div class="m-de-item-text">60天内</div>
        </div>
        <div class="m-data-explain-item">
          <div class="m-de-item-img tz-img2"></div>
        </div>
      </div>

      <div class="m-title-box" style="margin-top: 60px">
        场站运营
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        极能充智能运营中心提供多种营销策略和促销活动，运用大数据、人工智能等技术，在市场环境发生变化时自动生成营销活动及电价调整建议，并提供相应的业务预测，支撑场站提供餐饮、服务多种经营业态，增加客户的活跃度以及粘性，提高收益。
      </div>
      <div class="m-peculiarity">
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz6"></div>
          <div class="m-pe-text">
            <div>智能营销</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz7"></div>
          <div class="m-pe-text">
            <div>T+0结算</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz8"></div>
          <div class="m-pe-text">
            <div>灵活计费</div>
            <div>策略</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz9"></div>
          <div class="m-pe-text">
            <div>支持多种</div>
            <div>业态</div>
          </div>
        </div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">600<span>车次</span></div>
          <div class="m-de-item-text">日均车次最高可达</div>
          <div class="m-de-item-text">600车次</div>
        </div>
        <div class="m-data-explain-item"></div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">40<span>%</span></div>
          <div class="m-de-item-text">单枪日均使用率</div>
          <div class="m-de-item-text">可达40%以上</div>
        </div>
        <div class="m-data-explain-item">
          <div class="m-de-item-img tz-img3"></div>
        </div>
      </div>

      <div class="m-title-box" style="margin-top: 60px">
        场站运维
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        通过极能充平台提供的安防监控系统，可有效预防各类事故发生，维护人生、财产安全、保证充电设施安全稳定进行。专业维护团队7*24小时线上线下服务，实现场站无人值守自动化运营。
      </div>
      <div class="m-peculiarity">
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz10"></div>
          <div class="m-pe-text">
            <div>平台信息</div>
            <div>支撑</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz11"></div>
          <div class="m-pe-text">
            <div>智能远程</div>
            <div>监控</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tz12"></div>
          <div class="m-pe-text">
            <div>充电主动</div>
            <div>预警</div>
          </div>
        </div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">7*24<span>小时</span></div>
          <div class="m-de-item-text">提供线上线下</div>
          <div class="m-de-item-text">服务</div>
        </div>
        <div class="m-data-explain-item"></div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">99<span>%</span></div>
          <div class="m-de-item-text">充电桩可靠率</div>
          <div class="m-de-item-text">99%以上</div>
        </div>
        <div class="m-data-explain-item">
          <div class="m-de-item-img tz-img4"></div>
        </div>
      </div>

      <div class="m-title-box" style="margin-top: 40px">
        合作模式
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        平台可为充电场投资商提供多种合作模式，投资商可根据自身实际情况选择适合自己的合作模式。
      </div>
      <div class="m-hz-describe">
        <table>
          <tr>
            <td>模式/项目</td>
            <td>
              <div>建站方案</div>
              <div>策划</div>
            </td>
            <td>
              <div>场站建设</div>
              <div>实施</div>
            </td>
            <td>
              <div>平台代管</div>
              <div>运营</div>
            </td>
          </tr>
          <tr>
            <td>建站策划</td>
            <td><span></span></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>工程总包</td>
            <td><span></span></td>
            <td><span></span></td>
            <td></td>
          </tr>
          <tr>
            <td>工程总包、代管</td>
            <td><span></span></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>
        </table>
      </div>

      <div class="m-title-box" style="margin-top: 40px">
        预选合作方案
        <div class="m-title-line"></div>
      </div>
      <div class="m-hzfa-question">
        <div class="question">您想在哪座城市投资充电场？</div>
        <div class="question-item">
          <treeselect
            v-model="value"
            placeholder="请选择"
            :options="area"
            :class="{ 'border-color': !!value }"
            :disable-branch-nodes="true"
            :clearable="false"
            :load-options="handleItemChange"
          />
        </div>
      </div>
      <div class="m-hzfa-question">
        <div class="question">您想投资多大面积的充电场？</div>
        <div class="question-item">
          <div
            class="question-option"
            :class="{ 'select-option': mj === 200 }"
            @click="(mj = 200), (tzData.addArea = '600㎡以下')"
          >
            600㎡以下<span></span>
          </div>
          <div
            class="question-option"
            :class="{ 'select-option': mj === 300 }"
            @click="(mj = 300), (tzData.addArea = '600㎡-10000㎡')"
          >
            600㎡-10000㎡<span></span>
          </div>
          <div
            class="question-option"
            :class="{ 'select-option': mj === 380 }"
            @click="(mj = 380), (tzData.addArea = '10000㎡-15000㎡')"
          >
            10000㎡-15000㎡<span></span>
          </div>
          <div
            class="question-option"
            :class="{ 'select-option': mj === 420 }"
            @click="(mj = 420), (tzData.addArea = '15000㎡以上')"
          >
            15000㎡以上<span></span>
          </div>
        </div>
      </div>

      <div class="m-hzfa-question">
        <div class="question">您想在充电场使用多大规格的充电桩？</div>
        <div class="question-item">
          <div
            class="question-option"
            :class="{ 'select-option': gm === 1 }"
            @click="(gm = 1), (tzData.addCharging = '60kw以下')"
          >
            60kw以下<span></span>
          </div>
          <div
            class="question-option"
            :class="{ 'select-option': gm === 2 }"
            @click="(gm = 2), (tzData.addCharging = '60-90kw')"
          >
            60-90kw<span></span>
          </div>
          <div
            class="question-option"
            :class="{ 'select-option': gm === 3 }"
            @click="(gm = 3), (tzData.addCharging = '90-120kw')"
          >
            90-120kw<span></span>
          </div>
          <div
            class="question-option"
            :class="{ 'select-option': gm === 4 }"
            @click="(gm = 4), (tzData.addCharging = '120kw以上')"
          >
            120kw以上<span></span>
          </div>
        </div>
      </div>
      <div class="m-hzfa-question">
        <div class="question">您想采用哪种合作模式？</div>
        <div class="question-item">
          <div
            class="question-option"
            :class="{ 'select-option': hzms === 'a' }"
            @click="(hzms = 'a'), (tzData.addCooperationMode = '建站方案策划')"
          >
            建站方案策划<span></span>
          </div>
          <div
            class="question-option"
            :class="{ 'select-option': hzms === 'b' }"
            @click="
              (hzms = 'b'),
                (tzData.addCooperationMode = '建站方案策划+场站建设实施')
            "
          >
            建站方案策划+场站建设实施<span></span>
          </div>
          <div
            class="question-option"
            style="padding: 10px 50px 10px 20px; line-height: 20px"
            :class="{ 'select-option': hzms === 'c' }"
            @click="
              (hzms = 'c'),
                (tzData.addCooperationMode =
                  '建站方案策划+场站建设实施+场站委托运营')
            "
          >
            建站方案策划+场站建设实施+场站委托运营<span></span>
          </div>
        </div>
      </div>
      <div class="m-hzfa-question-jg">
        <!--          <div class="text1">预估所需投资总费用</div>-->
        <!--          <div class="text2">{{result}}<span>元</span></div>-->
        <div class="text3">
          *
          想了解更详细、精准的合作方案以及费用,可点击下方按钮留下您的联系方式,我们将派专人为您详细解答。
        </div>
      </div>
    </div>
    <div class="mobile-btns">
      <div class="m-btn" @click="gotoPage">我要投资</div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: { Treeselect },
  data() {
    return {
      value: "510100",
      area: [],
      mIsCity: true,
      mj: 200,
      gm: 1,
      hzms: "a",

      tzData: {
        name: "", //姓名
        telephone: "", //
        email: "", //
        cityCode: "510100", //
        city: "四川省成都市", //
        businessType: "投资", //业务类型 1-大客户 2-投资 3-加盟
        addCity: "成都", //加盟城市
        addArea: "600㎡以下", //加盟面积
        addCharging: "60kw以下", //充电桩
        addCooperationMode: "建站方案策划", //合作模式
        addEstimatedCost: "50000.00", //加盟预计费用
        path: "/intelligentlogistics",
      },
    };
  },
  computed: {
    result() {
      if (this.hzms === "a") {
        this.tzData.addCooperationMode = "建站方案策划";
        return (this.tzData.addEstimatedCost = "50000.00");
      } else if (this.hzms === "b") {
        this.tzData.addCooperationMode = "建站方案策划+场站建设实施";
        if (this.mj === 200) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "1400000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "1500000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "1700000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "2000000.00");
        } else if (this.mj === 300) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "1700000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "1900000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "2100000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "2400000.00");
        } else if (this.mj === 380) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "2000000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "2200000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "2400000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "2700000.00");
        } else if (this.mj === 420) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "2300000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "2500000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "2700000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "3000000.00");
        }
      } else {
        this.tzData.addCooperationMode =
          "建站方案策划+场站建设实施+场站委托运营";
        if (this.mj === 200) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "1600000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "1700000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "1900000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "2200000.00");
        } else if (this.mj === 300) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "2000000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "2200000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "2400000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "2700000.00");
        } else if (this.mj === 380) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "2380000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "2580000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "2780000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "3080000.00");
        } else if (this.mj === 420) {
          if (this.gm === 1)
            return (this.tzData.addEstimatedCost = "2720000.00");
          else if (this.gm === 2)
            return (this.tzData.addEstimatedCost = "2920000.00");
          else if (this.gm === 3)
            return (this.tzData.addEstimatedCost = "3120000.00");
          else if (this.gm === 4)
            return (this.tzData.addEstimatedCost = "3420000.00");
        }
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/primary/infos"
      )
        .then((res) => {
          let data = res.data;
          if (data.success) {
            data.data.map((item) => {
              if (
                item.areaId === "820000" ||
                item.areaId === "810000" ||
                item.areaId === "710000"
              ) {
                this.area.push({
                  id: item.areaId,
                  label: item.areaName,
                });
              } else if (item.areaId === "510000") {
                this.handleItemChangeInit({
                  id: item.areaId,
                  label: item.areaName,
                  children: [],
                });
              } else {
                this.area.push({
                  id: item.areaId,
                  label: item.areaName,
                  children: null,
                });
              }
            });
          }
        })
        .catch();
    },
    handleItemChange({ action, parentNode, callback }) {
      let me = this;
      let areaId = parentNode.id;
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/subordinate/infos?areaId=" +
          areaId
      )
        .then((res) => {
          let data = res.data;
          if (data.success) {
            me.area.map((item) => {
              if (item.id === areaId) {
                item.children = data.data.map((vv) => {
                  return {
                    id: vv.areaId,
                    label: vv.areaName,
                  };
                });
              }
            });
            callback();
          }
        })
        .catch();
    },
    handleItemChangeInit(row) {
      let me = this;
      let areaId = 510000;
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/subordinate/infos?areaId=" +
          areaId
      )
        .then((res) => {
          let data = res.data;
          if (data.success) {
            row.children = data.data.map((vv) => {
              return {
                id: vv.areaId,
                label: vv.areaName,
              };
            });
            me.area.push(row);
          }
        })
        .catch();
    },
    gotoPage() {
      this.$router.push({
        name: "mobileApply",
        params: this.tzData,
      });
    },
  },
};
</script>
<style src="./../../styles/mobile.less" lang="less" scoped></style>
